import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Shield, Star, ThumbsUp, Home } from 'lucide-react';
export function Difference() {
  const values = [{
    icon: <Home size={20} data-id="element-126" />,
    text: "A home they're proud to come back to every day"
  }, {
    icon: <Shield size={20} data-id="element-127" />,
    text: 'A contractor they can fully trust'
  }, {
    icon: <Star size={20} data-id="element-128" />,
    text: 'Results that exceed expectations'
  }, {
    icon: <ThumbsUp size={20} data-id="element-129" />,
    text: 'A process that feels easy and stress-free'
  }, {
    icon: <Heart size={20} data-id="element-130" />,
    text: 'A team that treats their home like their own'
  }];
  return <section className="py-20 bg-white" data-id="element-131">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center" data-id="element-133">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-134">
            <div className="flex items-center gap-4 mb-6" data-id="element-135">
              <div className="h-px w-12 bg-gold" data-id="element-136"></div>
              <span className="text-gold font-bold uppercase tracking-widest text-xs" data-id="element-137">
                Why Choose Us
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-navy mb-8" data-id="element-138">
              The Blue Sky Difference
            </h2>
            <p className="text-xl text-muted mb-12 font-light" data-id="element-139">
              We believe every Pennsylvania homeowner deserves:
            </p>

            <div className="space-y-8" data-id="element-140">
              {values.map((value, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-center gap-6 group" data-id="element-141">
                  <div className="flex-shrink-0 w-12 h-12 bg-cream rounded-full flex items-center justify-center text-navy border border-gray-100 group-hover:bg-navy group-hover:text-white transition-colors duration-300" data-id="element-142">
                    {value.icon}
                  </div>
                  <p className="text-lg font-medium text-navy tracking-wide" data-id="element-143">
                    {value.text}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative" data-id="element-144">
            <div className="bg-navy p-12 md:p-16 rounded-2xl text-center relative overflow-hidden shadow-[0_20px_50px_-12px_rgba(27,42,74,0.3)]" data-id="element-145">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-146"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-147"></div>

              <div className="relative z-10" data-id="element-148">
                <img src="https://cdn.magicpatterns.com/uploads/mHQYWDhNJXGSPsTWooPTGm/Photoroom_20260425_171611.png" alt="Blue Sky Logo" className="w-24 h-auto mx-auto mb-10 opacity-90" data-id="element-149" />
                <p className="text-2xl md:text-3xl font-heading font-light text-white leading-relaxed italic mb-10" data-id="element-150">
                  "We don't just build things. We build confidence, pride, and
                  the feeling of home."
                </p>
                <div className="pt-8 border-t border-white/10" data-id="element-151">
                  <p className="text-gold font-bold uppercase tracking-[0.2em] text-xs" data-id="element-152">
                    Blue Sky General Contractor LLC
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}